/**
 * Theme colors for Sentence Studio.
 * Returns a flat object of semantic color tokens based on dark/light mode.
 * Used exclusively by SentenceStudio.jsx inline styles.
 */
export function getThemeColors(dark) {
  return {
    // ── Backgrounds ──
    bg:              dark ? "#08080c" : "#f9fafb",
    cardBg:          dark ? "#0b0b12" : "#ffffff",
    inputBg:         dark ? "#08080c" : "#f9fafb",
    activeBtnBg:     dark ? "#1e1e3a" : "#eef2ff",
    disabledBtnBg:   dark ? "#1a1a2a" : "#f3f4f6",
    activeToggleBg:  dark ? "#111118" : "#f3f4f6",
    activePresetBg:  dark ? "#1a1a2e" : "#eef2ff",
    tokenHoverBg:    dark ? "#ffffff08" : "#6366f118",
    iconBadgeBgOn:   dark ? "#ffffff08" : "#6366f110",
    iconBadgeBgOff:  dark ? "#ffffff04" : "#00000004",

    // ── Borders ──
    border:              dark ? "#15151f" : "#e5e7eb",
    inputBorder:         dark ? "#1e1e2e" : "#d1d5db",
    inputFocusBorder:    dark ? "#333333" : "#6366f1",
    buttonBorder:        dark ? "#2a2a4a" : "#c7d2fe",
    presetBorder:        dark ? "#1a1a2a" : "#e5e7eb",
    presetActiveBorder:  dark ? "#2a2a4a" : "#a5b4fc",
    iconBadgeBorderOn:   dark ? "#818cf825" : "#6366f125",
    iconBadgeBorderOff:  dark ? "#ffffff06" : "#00000006",

    // ── Accent ──
    accent:  dark ? "#818cf8" : "#6366f1",

    // ── Text ──
    textBody:          dark ? "#e5e5e5" : "#1f2937",
    textTitle:         dark ? "#ffffff" : "#111827",
    textTextarea:      dark ? "#d4d4d4" : "#374151",
    textToken:         dark ? "#cccccc" : "#4b5563",
    textTokenSelected: dark ? "#eeeeee" : "#1f2937",
    textMuted1:        dark ? "#888888" : "#6b7280",
    textMuted2:        dark ? "#777777" : "#6b7280",
    textMuted3:        dark ? "#666666" : "#9ca3af",
    textMuted4:        dark ? "#555555" : "#9ca3af",
    textMuted5:        dark ? "#444444" : "#9ca3af",
    textDim:           dark ? "#333333" : "#d1d5db",
    textSubhead:       dark ? "#3a3a4a" : "#9ca3af",
    textScrollHint:    dark ? "#1e1e2e" : "#d1d5db",
    textEmptyState:    dark ? "#2a2a3a" : "#9ca3af",
    disabledText:      dark ? "#555555" : "#9ca3af",

    // ── Card shadows (light mode only) ──
    cardShadow:  dark ? "none" : "0 1px 3px rgba(0,0,0,0.08)",
  };
}
